/**
 * Transient confirmation painted INSIDE the video frame.
 *
 * The member app's `<Toaster/>` is mounted at the app root, outside the
 * fullscreen element — so in fullscreen a toast renders nowhere. Anything the
 * learner needs to see there (bookmark saved, speed changed, resumed from…)
 * comes through here instead.
 */
export function PlayerNotice({ message }: { message: string | null }) {
  return (
    <div
      aria-live="polite"
      className={`pointer-events-none absolute left-3 top-3 rounded-md bg-black/70 px-2.5 py-1 text-xs font-medium text-white transition-opacity ${
        message ? 'opacity-100' : 'opacity-0'
      }`}
    >
      {message ?? ''}
    </div>
  );
}
